// extracted by mini-css-extract-plugin
export default {"modalBody":"ConfirmActionModal_modalBody__vl69t"};